import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines } from "./Reveal";

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const yBg = useTransform(scrollYProgress, [0, 1], ["0%", "35%"]);
  const scaleBg = useTransform(scrollYProgress, [0, 1], [1, 1.15]);
  const yText = useTransform(scrollYProgress, [0, 1], ["0%", "-20%"]);
  const opacity = useTransform(scrollYProgress, [0, 0.7], [1, 0]);

  return (
    <section
      id="top"
      ref={ref}
      data-testid="hero-section"
      className="relative h-screen w-full overflow-hidden"
    >
      {/* Parallax background */}
      <motion.div style={{ y: yBg, scale: scaleBg }} className="absolute inset-0 -z-10">
        <img
          src="https://images.unsplash.com/photo-1471341971476-ae15ff5dd4ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMHN0dWRpbyUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4NTE1MjMyNXww&ixlib=rb-4.1.0&q=85"
          alt="Studio lighting"
          className="h-full w-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background/70 via-background/50 to-background" />
      </motion.div>

      {/* Blue label band */}
      <motion.div
        style={{ opacity }}
        className="absolute top-20 left-0 right-0 bg-primary text-primary-foreground py-3 px-6 lg:px-12 flex justify-between items-center text-[10px] sm:text-xs uppercase tracking-[0.25em] font-bold"
      >
        <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.2 }}>
          Strategy & Creatives
        </motion.span>
        <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.35 }} className="hidden sm:block">
          Brand Solutions
        </motion.span>
        <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.5 }}>
          Video Content Solutions
        </motion.span>
      </motion.div>

      {/* Kinetic headline */}
      <motion.div
        style={{ y: yText, opacity }}
        className="absolute bottom-16 lg:bottom-20 left-6 lg:left-12 right-6 lg:right-12"
      >
        <MaskLines
          animate
          lines={["Sixes", <><span className="text-primary">&amp;</span> Sevens</>]}
          className="font-display font-extrabold uppercase leading-[0.82] tracking-tighter text-[19vw] lg:text-[15vw]"
          delay={0.15}
          stagger={0.14}
        />
        <div className="mt-6 lg:mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6 items-end">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, duration: 0.8 }}
            className="lg:col-span-6 lg:col-start-1 font-body text-xl lg:text-3xl text-foreground/80 max-w-2xl leading-snug"
          >
            An end-to-end creative studio building brands and the{" "}
            <span className="font-accent text-primary text-2xl lg:text-4xl">films</span> that make them
            unforgettable.
          </motion.p>
        </div>
      </motion.div>
    </section>
  );
};
